import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import _ from 'lodash';

import { GetPushBroadcastPeopleQuery, GetPushBroadcastPeopleQueryVariables } from '../../../../../__gqltypes__';
import { GET_PUSH_BROADCAST_PEOPLE } from './graphql';
import { PushPerson } from './utils';

/** Names of the accounts behind the user ids a broadcast records. Unresolved ids are shown as ids. */
export function usePushPeople(ids: ReadonlyArray<string | null | undefined>): ReadonlyMap<string, PushPerson> {
  // A stable key: the caller's array is rebuilt on every render.
  const key = _.sortBy(_.uniq(ids.filter((id): id is string => !!id))).join(',');
  const uniqueIds = useMemo(() => (key ? key.split(',') : []), [key]);
  const { data } = useQuery<GetPushBroadcastPeopleQuery, GetPushBroadcastPeopleQueryVariables>(
    GET_PUSH_BROADCAST_PEOPLE,
    { variables: { ids: uniqueIds }, skip: uniqueIds.length === 0 }
  );
  return useMemo(() => new Map((data?.users ?? []).map((user) => [user.id, user])), [data]);
}
